import React from "react"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import { EventObjectDto } from "../../../state/event/Event"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import Proposal from "../../../state/proposal/Proposal"
import { QuoteDto } from "../../../state/quote/Quote"

type OwnProps = {
    object: EventObjectDto
    quote: QuoteDto
    proposal: Proposal
}

const QuoteExportedToMailchimpEvent = (props: OwnProps) => {
    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"}>
                    {<FormattedMessage
                        id="quote.analytics.events.exported.mailchimp.text"
                        defaultMessage="Quote {identifier} was exported to Mailchimp as a cart"
                        values={{
                            identifier: <strong>{props.quote.attributes.identifier}</strong>,
                        }}
                    />}
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={"#"} rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(INTEGRATION_KEY.MAILCHIMP, 150)}
                    </a>
                </div>

            </div>
        </div>
    )
}


export default QuoteExportedToMailchimpEvent



// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-exported-mailchimp.component.tsx